import { render, staticRenderFns } from "./ServicerDropdownField.vue?vue&type=template&id=60943b66"
import script from "./ServicerDropdownField.vue?vue&type=script&lang=ts"
export * from "./ServicerDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60943b66')) {
      api.createRecord('60943b66', component.options)
    } else {
      api.reload('60943b66', component.options)
    }
    module.hot.accept("./ServicerDropdownField.vue?vue&type=template&id=60943b66", function () {
      api.rerender('60943b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/ServicerDropdownField.vue"
export default component.exports